import React, { useState, useMemo, useCallback } from "react";
import { Modal, message } from "antd";
import { connect, useLocation } from "dva";
import { QuoteStatus } from "@/utils/enum";
import { getQuotesByStatus } from "@/services/quotes_new";
import { multiplePostShipment } from "@/services/shipments";
import ListView from "@/components/ListView";
import { ListToBeSorted } from "@/components/SortAndFilter";
import useQuotesTableColumns from "./utils/useQuotesTableColumns";

const Quotes = ({ configPerm }) => {
  const { pathname } = useLocation();

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const isAdmin = useMemo(() => configPerm["CoreService.AdminShipments"], [configPerm]);

  const columns = useQuotesTableColumns({
    isCompleted: quoteStatus === QuoteStatus.Completed,
  });

  const currentSubPath = useMemo(() => pathname.split("/").pop(), [pathname]);

  const quoteStatus = useMemo(() => {
    switch (pathname) {
      case "/quotes/pending":
        return QuoteStatus.Pending;

      case "/quotes/completed":
        return QuoteStatus.Completed;
    }
  }, [pathname]);

  const [selectedShipments, setSelectedShipments] = useState([]);
  const [formVisible, setFormVisible] = useState(false);
  const [entityLoading, setEntityLoading] = useState(false);

  const fetchQuotesList = useCallback(
    async ({ filters }) => {
      try {
        const response = await getQuotesByStatus({
          ...filters,
          quoteStatus,
        });

        return {
          data: response?.items ?? [],
          total: response?.totalCount ?? 0,
          success: true,
        };
      } catch (error) {
        return {
          data: [],
          total: 0,
        };
      }
    },
    [quoteStatus],
  );

  const handleModalSubmit = useCallback(() => {
    if (!selectedShipments.length) {
      message.error("No shipments selected");
      return;
    }

    setEntityLoading(true);

    const shipmentsPayload = selectedShipments.map(row => row.id);

    multiplePostShipment(shipmentsPayload).then(() => {
      setFormVisible(false);
      setEntityLoading(false);
      message.success("Shipments have been accepted");
    });
  }, [selectedShipments]);

  const handleModalCancel = useCallback(() => {
    setFormVisible(false);
    setEntityLoading(false);
  }, []);

  const handleModalClose = useCallback(() => {
    setSelectedShipments([]);
  }, []);

  const toolBarRender = useMemo(() => {
    return function render() {
      if (selectedRowKeys.length === 0 || quoteStatus !== QuoteStatus.Completed) {
        return null;
      }

      if (!configPerm["CoreService.AdminShipments.Post"] && !configPerm["CoreService.Shipments.Post"]) {
        // TODO: Check if these permissions are correct
        return null;
      }

      return null;

      // return (
      //   <Button
      //     type="primary"
      //     onClick={() => handleModalOpen(selectedRowKeys)}
      //   >
      //     Post {selectedRowKeys.length} Shipment(s)
      //   </Button>
      // );
    };
  }, [selectedRowKeys, quoteStatus, configPerm]);

  return (
    <ListView
      filterType={ListToBeSorted.Quotes}
      columns={columns}
      baseDetailsUrl={`/quotes/${isAdmin ? "admin/" : ""}${currentSubPath}/view`}
      detailsUrlParamName="shipmentId"
      request={fetchQuotesList}
      toolBarRender={toolBarRender}
      rowSelection={
        quoteStatus === QuoteStatus.Pending
          ? false
          : {
              selectedRowKeys,
              onChange: setSelectedRowKeys,
            }
      }
    >
      {quoteStatus === QuoteStatus.Completed && (
        <Modal
          title="Post Shipments"
          visible={formVisible}
          onOk={handleModalSubmit}
          onCancel={handleModalCancel}
          afterClose={handleModalClose}
          confirmLoading={entityLoading}
        >
          <div>Confirm that you are posting {selectedShipments.length} shipment(s).</div>
        </Modal>
      )}
    </ListView>
  );
};

export default connect(({ configs }) => ({
  configPerm: configs.configPerm,
}))(Quotes);
